import Helpers from './Helpers'
import moment from 'moment'
import XHRPromise from 'xhr-promise'
import FlexibleBooking from './FlexibleBooking'

const availability = document.getElementsByClassName('property-availability')

const idDateFormat = 'YYYY-M-D'
const displayDateFormat = 'ddd D MMM YYYY'

const hoverClass = 'hover'
const hoverClassStart = 'hover-start'
const hoverClassEnd = 'hover-end'
const selectedClass = 'selected'
const selectedClassStart = 'selected-start'
const selectedClassEnd = 'selected-end'

const pricingFeed = '/feeds/pricingFeed.aspx';

const hintStart = 'Click the day you\'d like to arrive to reserve or check the price...'
const hintEnd = 'Now, click the day you\'d like to leave...'
const hintCalculating = 'Fetching pricing...'


class Availability {

    constructor(container) {
        this.container = container
        this.calendars = container.getElementsByClassName('property-calendar')
        this.pricingContainer = container.getElementsByClassName('property-availability__pricing')[0]
        this.messageContainer = container.getElementsByClassName('property-availability__message')[0]
        this.calendarCells = []
        Array.from(this.calendars).forEach((c) => {
            this.calendarCells = this.calendarCells.concat(Array.from(c.querySelectorAll('td[id]')))
        })

        this.displayStart = document.getElementsByClassName('property-availability__reserve-arriving')[0]
        this.displayEnd = document.getElementsByClassName('property-availability__reserve-departing')[0]
        this.adminFee = document.getElementsByClassName('property-availability__reserve-booking-fee')[0]
        this.adminFeeMobile = document.getElementsByClassName('property-availability__booking-fee-mobile-only')[0]
        this.displayTotal = document.getElementsByClassName('property-availability__reserve-total')[0]
        this.rentTotal = document.getElementsByClassName('property-availability__rent-total')[0]
        this.submitButton = document.querySelector('.property-availability__reserve-submit button')
        this.shortBreakLength = document.getElementsByClassName('property-availability__reserve-duration')[0]
        this.shortBreakButtons = document.querySelectorAll('#property-aside__short-breaks-buttons>li')

        this.flexibleBookingRadio = document.querySelectorAll('.cancel-anytime__item--radio.flex')[0]
        this.flexibleBookingPrice = document.querySelectorAll('.cancel-anytime__item--price.flexible')[0]

        this.flexAccordion = document.getElementById('flex-accordion')
        this.flexAccordionButton = document.querySelectorAll('.property-availability__mobile-toggle')[0]

        this.standardBookingRadio = document.querySelectorAll('.cancel-anytime__item--radio.standard')[0]
        this.standardBookingPrice = document.querySelectorAll('.cancel-anytime__item--price.standard')[0]

        this.flexBookingWrapper = document.querySelectorAll('.cancel-anytime-wrapper')[0]
        this.reserveWrapper = document.getElementsByClassName('property-availability__reserve')[0]

        this.form = new Helpers(this.submitButton).getClosest('form')
        this.pricingToggles = null
        if (document.getElementsByClassName('property-pricing__dates').length > 0) {
            this.pricingToggles = document.getElementsByClassName('property-pricing__dates')[0].getElementsByTagName('button')
        }

        this.cdrn = this.container.getAttribute('data-cdrn')
        this.cottageCode = this.container.getAttribute('data-cottagecode')

        this.startDate = null
        this.endDate = null
        this.canReserve = false

        this.readDisplayDates()
        this.setDisplayDates()

        this.listeners()
        this.flexibleBooking = new FlexibleBooking(this.container)
    }

    listeners() {
        if (!window.IS_TOUCH_DEVICE) {
            new Helpers(this.calendarCells).eventListener((e) => {
                this.hoverAction(e.currentTarget)
            }, 'mouseover')


            new Helpers(this.container).eventListener((e) => {
                this.clearHighlight()
                this.clearOfferHighlight()
            }, 'mouseout')
        }

        new Helpers(this.calendarCells).eventListener((e) => {
            this.clickAction(e.currentTarget)
        })

        this.form.onsubmit = () => this.submitAction()

        if (this.pricingToggles !== null) {
            new Helpers(this.pricingToggles).eventListener((e) => {
                const year = e.currentTarget.getAttribute('data-year')
                this.changePricingYear(year)
            })
        }
        try {
            if (sessionStorage.searchDates) {
                this.loadSearchDates()
            }
        } catch (e) {
            console.log(e)
        }
        if (this.shortBreakButtons !== null) {
            new Helpers(this.shortBreakButtons).eventListener((e) => {
                const buttons = document.getElementById('property-aside__short-breaks-buttons').getElementsByTagName('li')
                new Helpers(buttons).removeClass('enabled')
                new Helpers(e.currentTarget).addClass('enabled')
                const value = parseInt(e.currentTarget.getAttribute('data-short-break-minimum-click'), 10)
                this.highlightShortBreaks(value)
            })
        }

        new Helpers(this.pricingContainer).eventListener((e) => {
            // only use this on mobile.
            if (window.outerWidth > 600) return
            // if its the stop element, the click would be for the "clear dates" psuedo button
            if (new Helpers(e.target).hasClass('stop')) {
                this.clearSelected()
                this.startDate = null
                this.endDate = null
                this.setDisplayDates()
            }
        })
        new Helpers(this.flexibleBookingRadio).eventListener((e) => {
            this.updateTotalPriceFromBookingOption(document.querySelectorAll('.cancel-anytime__item--price.flexible')[0].innerHTML, document.querySelectorAll('.discount').length > 0)
        })
        new Helpers(this.standardBookingRadio).eventListener((e) => {
            this.updateTotalPriceFromBookingOption(document.querySelectorAll('.cancel-anytime__item--price.standard')[0].innerHTML, document.querySelectorAll('.discount').length > 0)
        })

    }

    cellDate(cell) {
        const id = cell.id
        return moment(id, idDateFormat).toDate()
    }

    cellId(date) {
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    }

    hoverAction(cell) {
        const el = new Helpers(cell)

        if (this.startDate === null) {
            // start hover
            if (el.hasClass('unavailable') || el.hasClass('unavailable-start')) {
                this.clearHighlight()
            } else {
                this.highlightRange(this.cellDate(cell), null, true)
            }
        } else if (this.endDate === null) {
            // end hover
            if (el.hasClass('unavailable') || el.hasClass('unavailable-end')) {
                this.clearHighlight()
            } else {
                this.highlightRange(this.startDate, this.cellDate(cell), true)
            }
        }

        // check for SO
        this.clearOfferHighlight()
        const offerSubCell = cell.getElementsByTagName('span')
        if (offerSubCell.length) {
            const offerIndex = offerSubCell[0].getAttribute('data-offer').split('-')[1]
            if (offerIndex !== '0') {
                this.highlightOfferCells(offerIndex)
            }
        }
    }

    highlightOfferCells(offerIndex) {
        this.calendarCells.forEach((c) => {
            const offerSubCell = c.getElementsByTagName('span')
            if (offerSubCell.length) {
                const data = offerSubCell[0].getAttribute('data-offer')
                if (data.indexOf(offerIndex) >= 0) {
                    new Helpers(offerSubCell[0]).addClass('highlight')
                }
            }
        })
    }
    clearOfferHighlight() {
        this.calendarCells.forEach((c) => {
            const offerSubCell = c.getElementsByTagName('span')
            if (offerSubCell.length) {
                new Helpers(offerSubCell[0]).removeClass('highlight')
            }
        })
    }

    clickAction(cell) {
        const el = new Helpers(cell)

        if (this.startDate === null) {
            // start
            if (!el.hasClass('unavailable') && !el.hasClass('unavailable-start')) {
                this.startDate = this.cellDate(cell)
            }
        } else if (this.endDate === null) {
            // end
            if (!el.hasClass('unavailable') && !el.hasClass('unavailable-end')) {
                this.endDate = this.cellDate(cell)
                if (this.endDate <= this.startDate) {
                    // if the dates are invalid, clear
                    this.clearSelected()
                    this.startDate = null
                    this.endDate = null
                } else {
                    this.scrollToPricing()
                }
            }
        } else {
            this.clearSelected()
            this.startDate = this.cellDate(cell)
            this.endDate = null
        }

        this.highlightRange(this.startDate, this.endDate)
        this.setDisplayDates()
        if (this.startDate !== null && this.endDate !== null) {
            this.calc()
        }

        // Reset searchDates as the user has clicked availability grid.
        try {
            sessionStorage.removeItem('searchDates')
        } catch (e) {
            console.log(e)
        }
    }

    submitAction() {
        this.scrollToPricing()
        return this.canReserve
    }

    scrollToPricing() {
        if (window.outerWidth > 600) {
            const observer = new IntersectionObserver((entries) => {
                if (!entries[0].isIntersecting) {
                    this.form.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                observer.disconnect();
            }, { threshold: 1.0 });

            observer.observe(this.form);
        }
    }

    clearHighlight() {
        // reset hover UI
        new Helpers(this.calendarCells)
            .removeClass(hoverClass, hoverClassStart, hoverClassEnd)
    }

    clearSelected() {
        new Helpers(this.calendarCells)
            .removeClass(selectedClass, selectedClassStart, selectedClassEnd)
    }

    highlightRange(startDate, endDate, hover = false) {
        this.clearHighlight()

        if (startDate === null && endDate === null) {
            return
        }

        if (endDate === null) {
            endDate = startDate
        }

        // first cell
        const d = new Date(startDate)
        while (d <= endDate) {
            const cellId = this.cellId(d)
            const cell = document.getElementById(cellId)
            if (cell !== undefined) {
                const start = moment(d).isSame(startDate)
                const end = moment(d).isSame(endDate)

                if (start) {
                    new Helpers(cell).addClass(hover ? hoverClassStart : selectedClassStart)
                }

                if (end && !start) {
                    new Helpers(cell).addClass(hover ? hoverClassEnd : selectedClassEnd)
                }

                if (!start && !end) {
                    new Helpers(cell).addClass(hover ? hoverClass : selectedClass)
                }
            }
            // move to the next day
            d.setDate(d.getDate() + 1)
        }
    }

    readDisplayDates() {
        try {
            const startDate = moment(this.displayStart.value, displayDateFormat)
            const endDate = moment(this.displayEnd.value, displayDateFormat)
            if (startDate.isValid() && endDate.isValid()) {
                this.startDate = startDate.toDate()
                this.endDate = endDate.toDate()
                this.highlightRange(this.startDate, this.endDate, false)
                new Helpers(this.reserveWrapper).addClass('has-dates')
                this.calc()
            }
        } catch (ex) {
            this.startDate = null
            this.endDate = null
            this.setDisplayDates()
        }
    }

    setDisplayDates() {
        this.displayStart.value = this.startDate === null ? '' : moment(this.startDate).format(displayDateFormat)
        this.displayEnd.value = this.endDate === null ? '' : moment(this.endDate).format(displayDateFormat)
        this.displayTotal.value = ''

        this.adminFee.value = ''
        this.adminFeeMobile.value = ''
        new Helpers(this.submitButton).addClass('disabled')
        new Helpers(this.reserveWrapper).removeClass('can-reserve')

        if (this.startDate === null) {
            this.pricingContainer.innerHTML = hintStart
            new Helpers(this.reserveWrapper).removeClass('has-dates')
        } else if (this.endDate === null) {
            this.pricingContainer.innerHTML = hintEnd
            new Helpers(this.reserveWrapper).addClass('has-dates')
        } else {
            this.pricingContainer.innerHTML = hintCalculating
            new Helpers(this.reserveWrapper).addClass('has-dates')
        }
    }

    calc() {
        const xhr = new XHRPromise()
        const fromDate = moment(this.startDate).format('DD/MM/YYYY')
        const toDate = moment(this.endDate).format('DD/MM/YYYY')

        xhr.send({
            url: `${pricingFeed}?c=${this.cdrn}&h=${fromDate},${toDate}&business=cc`,
        })
            .then(response => (new window.DOMParser()).parseFromString(response.responseText, 'text/xml'))
            .then((data) => {
                this.displayPricing(data)
                this.recordPricing(data)
            }).catch((e) => {
                console.log(e)
            })
    }

    recordPricing(data) {
        // Push response from pricing feed to the datalayer, exposing it for use in TagManager.
        // https://trello.com/c/iLl7NGFD

        if (data.getElementsByTagName('Result').length) {
            const result = data.getElementsByTagName('Result')[0]
            const pricedHolidays = Array.from(data.getElementsByTagName('pricedHoliday'))

            const fullPrice = (pricedHolidays.length > 0 ? pricedHolidays[0].getAttribute('Price') : 0)
            const holidayDesc = result.getAttribute('HolidayDesc')
            const showRent = result.getAttribute('ShowRent') === 'Y'
            const canReserve = result.getAttribute('CanReserve') === 'Y'
            const warning = result.getAttribute('WarningMessage')

            const startDate = moment(this.displayStart.value, displayDateFormat)
            const endDate = moment(this.displayEnd.value, displayDateFormat)
            const nights = endDate.diff(startDate, 'days')

            window.dataLayerQueue.push({
                'event': 'priceLookup'
                , 'cottageCode': this.cottageCode
                , 'arrivalDate': startDate.format('YYYY-MM-DD')
                , 'nights': nights
                , 'price': fullPrice
                , 'warningMessage': warning
                , 'canReserve': canReserve
            })
        }
    }

    updateTotalPriceFromBookingOption(price, lowOccupancy = false) {
        var totalPrice = parseFloat(price) + parseFloat(this.adminFee.getAttribute('data-fee'))
        this.displayTotal.value = this.formatPriceForDisplay(totalPrice, lowOccupancy)
        this.rentTotal.value = totalPrice
    }


    formatPriceForDisplay(price, lowOccupancy = false) {
        const formattedPrice = '£' + this.roundToTwoDecimalPlaces(price);
        return lowOccupancy ? `from ${formattedPrice}*` : formattedPrice;
    }

    roundToTwoDecimalPlaces(price) {
        price = parseFloat(price);
        return price.toFixed(2);
    }

    displayPricing(data) {
        // cler and reveal panel
        this.pricingContainer.innerHTML = ''
        this.displayTotal.value = ''

        new Helpers(this.submitButton).addClass('disabled')
        new Helpers(this.reserveWrapper).removeClass('can-reserve')

        if (data.getElementsByTagName('Result').length) {
            const result = data.getElementsByTagName('Result')[0]
            const pricedHolidays = Array.from(data.getElementsByTagName('pricedHoliday'))
            const holidayDesc = result.getAttribute('HolidayDesc')
            const showRent = result.getAttribute('ShowRent') === 'Y'
            const canReserve = result.getAttribute('CanReserve') === 'Y'
            const warning = result.getAttribute('WarningMessage')

            if (canReserve && showRent) {
                this.adminFee.value = this.formatPriceForDisplay(result.getAttribute('AdminFee'))
                this.adminFee.setAttribute('data-fee', result.getAttribute('AdminFee'))
                this.adminFeeMobile.innerHTML = `Booking fee: <strong>` + this.formatPriceForDisplay(result.getAttribute('AdminFee')) + `</strong>`
                this.pricingContainer.appendChild(this.pricedHolidaysMarkup(pricedHolidays, holidayDesc))

                this.setPriceDisplay(pricedHolidays)
                new Helpers(this.submitButton).removeClass('disabled')
                new Helpers(this.reserveWrapper).addClass('can-reserve')
                new Helpers(this.flexAccordion).addClass('accordion--active')
                this.flexAccordion.setAttribute('aria-expanded', 'true')
                new Helpers(this.flexAccordionButton).addClass('accordion-toggle--active')
            }
            if (warning !== '') {
                const stopMessage = document.createElement('p')
                const stopNote = document.createElement('p')

                stopNote.innerHTML = warning
                if (canReserve) {
                    // not blocked from reserving but the warning means that it'll need to be checked
                    stopNote.className = 'warning'
                    stopNote.innerHTML += ". We'll hold your dates and quickly check everything is ok before we confirm your booking."
                } else {

                    stopMessage.className = "stop"
                    stopMessage.innerHTML = "These dates aren't available online, but call us on 01326 555 555 and we will try to work something out for you."
                    this.flexBookingWrapper.setAttribute('aria-hidden', 'true')
                }
                this.pricingContainer.appendChild(stopMessage)
                this.pricingContainer.appendChild(stopNote)
                this.scrollToPricing()
            }

            if (canReserve) {
                const p = document.createElement('p')
                p.className = 'more-time'
                p.innerHTML = 'Need more time? Reserve for up to <strong>24&nbsp;hours</strong> or book now.'
                this.pricingContainer.appendChild(p)
            }

            this.canReserve = canReserve
        }
    }

    pricedHolidaysMarkup(pricedHolidays, holidayDesc) {

        const output = document.createElement('div')
        output.className = 'rent'

        if (pricedHolidays.length > 1) {
            var minPrice = 99999999
            var restrictionsForMinPrice = ''
            pricedHolidays.forEach((ph, k) => {
                const price = parseFloat(ph.getAttribute('Price'))
                if (price < minPrice) {
                    restrictionsForMinPrice = ph.getAttribute('Restrictions')
                    minPrice = price
                }
            })
            const p = document.createElement('p')
            p.innerHTML = `<span class="discount">* Includes ${restrictionsForMinPrice}</span>`
            output.appendChild(p)
        }
        return output
    }
    setPriceDisplay(pricedHolidays) {
        let minPrice = null
        let minBasePrice = null
        let count = 0

        pricedHolidays.forEach((ph) => {
            let basePrice = parseFloat(ph.getAttribute('Price'))
            let totalPrice = basePrice

            // iterate through line items
            Array.from(ph.getElementsByTagName('lineItem')).forEach((l) => {
                if (l.getAttribute('description') != 'Booking Fee') {
                    const value = parseFloat(l.getAttribute('value'))
                    totalPrice += value
                }
            })

            if (minPrice === null) {
                minPrice = totalPrice;
            } else {
                minPrice = Math.min(minPrice, totalPrice);
            }

            if (minBasePrice === null) {
                minBasePrice = basePrice;
            }
            minBasePrice = Math.min(minBasePrice, minPrice); 


            count += 1;
        })

        this.flexibleBooking.calcFlexibleBookingControl(minBasePrice, minBasePrice)
        this.updateTotalPriceFromBookingOption(minBasePrice, count > 1)

    }

    changePricingYear(year) {
        // toggle active button state
        Array.from(this.pricingToggles).forEach((button) => {
            const className = button.getAttribute('aria-controls')
            const controls = document.getElementsByClassName(className)
            const active = button.getAttribute('data-year') === year

            button.setAttribute('aria-current', active)
            new Helpers(controls).setAttributes({ 'aria-hidden': !active })

        })
        // toggle active pricing display

    }

    loadSearchDates() {
        if (!sessionStorage.searchDates) {
            return
        }
        if (this.displayStart.value !== '') {
            return
        }

        let dates = JSON.parse(sessionStorage.searchDates)
        let startDate = moment(dates['dss'])
        let endDate = moment(dates['des'])
        let duration = parseInt(dates['nday'])

        // If a short break duration was selected via search enable that selection.
        this.enableShortBreakButton(duration)
        this.highlightShortBreaks(duration)

        // Only accepts ISO 8601 strings
        if (!startDate.isValid() || !endDate.isValid()) {
            return
        }
        // Only display if exact holiday dates known.
        if (endDate.diff(startDate, 'days') !== duration) {
            return
        }

        // Update the UI.
        this.startDate = startDate.toDate()
        this.endDate = endDate.toDate()
        this.setDisplayDates()
        this.calc()
        this.highlightRange(this.startDate, this.endDate)
    }

    enableShortBreakButton(duration) {
        // Validate length.
        duration = parseInt(duration)
        if (duration < 2 || duration > 6) {
            return
        }

        var container = document.getElementById('property-aside__short-breaks-buttons')
        if (container === null) {
            return
        }
        var buttons = container.getElementsByTagName('li')
        var currentButton = document.getElementById('property-aside__short-breaks-buttons_' + duration)

        // If a button for the exact length is not available, search for the next best.
        if (currentButton === null) {
            var options = [];
            for (var index = 0; index < buttons.length; index++) {
                var item = buttons[index];
                var length = parseInt(item.getAttribute('data-short-break-minimum-click'))
                if (length < duration) {
                    options.push(length)
                }
            }
            if (options.length > 0) {
                var max = Math.max(...options)
                currentButton = document.getElementById('property-aside__short-breaks-buttons_' + max)
            }
        }

        // Add the class if a button has been found to use.
        if (currentButton !== null) {
            new Helpers(buttons).removeClass('enabled')
            new Helpers(currentButton).addClass('enabled')
        }
    }

    highlightShortBreaks(duration) {
        // Validate length.
        duration = parseInt(duration)
        if (duration < 2 || duration > 6) {
            return
        }

        // Loop all the short break day in the availability grids.
        var all = document.querySelectorAll('[data-short-break-state]')
        for (var index = 0; index < all.length; index++) {
            var item = all[index];
            var state = item.getAttribute('data-short-break-state')
            var minimum = parseInt(item.getAttribute('data-short-break-minimum'))
            var previousState = item.getAttribute('data-short-break-previous-state')
            var previousMinimum = parseInt(item.getAttribute('data-short-break-previous-minimum'))

            // Handle non-short break days.
            if (state !== 'ShortBreak' && previousState === 'ShortBreak') {
                new Helpers(item).removeClass(
                    'available-end',
                    'available-alt-end')
                new Helpers(item).addClass(previousMinimum <= duration ? 'available-alt-end' : 'available-end')
            }
            if (state !== 'ShortBreak') {
                continue
            }

            // Remove any existing classes from the current day.
            new Helpers(item).removeClass(
                'available-start',
                'available',
                'available-alt-start',
                'available-alt')

            var mainCssClass = ''
            var previousCssClass = ''

            // Set the days primary css class.
            if (minimum <= duration) {
                mainCssClass = 'available-alt'
            } else {
                mainCssClass = 'available'
            }

            // Handle change of state days (half-days).
            if (previousState !== 'ShortBreak' && previousState !== 'null') {
                mainCssClass += '-start'
                previousCssClass = previousState === 'Available' ? 'available-end' : 'unavailable-end'
            } else if (previousState === 'ShortBreak' && minimum <= duration && previousMinimum > duration) {
                mainCssClass += '-start'
                previousCssClass = 'available-end'
            } else if (previousState === 'ShortBreak' && minimum > duration && previousMinimum <= duration) {
                mainCssClass += '-start'
                previousCssClass = 'available-alt-end'
            }

            // Apply the css classes to the table cell.
            new Helpers(item).addClass(mainCssClass)
            if (previousCssClass !== '') {
                new Helpers(item).addClass(previousCssClass)
            }
        }
    }
}

if (availability.length) {
    const avail = new Availability(availability[0])
}